module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Описание технологического процесса <span class=\"required\"></span></td>\n			<td><control type=\"text\" target=\"item.description\"/></td>\n		</tr>\n		<tr>\n			<td>Требования к технологии</td>\n			<td><control type=\"text\" target=\"item.rationale\"/></td>\n		</tr>\n		<tr>\n			<td>Временной период</td>\n			<td><control type=\"datetimepicker\" target=\"item.datetime\"/></td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Субъекты, ответственные за техпроцесс</div>\n				<div class=\"processstep-processors\"></div>\n				<div class=\"buttons\"><button on-click=\"addProcessor\">Добавить</button></div>\n			</td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}